/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FastPreviewLookupDTO { 
    featureType?: FastPreviewLookupDTO.FeatureTypeEnum;
    featureSubType?: number;
}
export namespace FastPreviewLookupDTO {
    export type FeatureTypeEnum = 0 | 1;
    export const FeatureTypeEnum = {
        NUMBER_0: 0 as FeatureTypeEnum,
        NUMBER_1: 1 as FeatureTypeEnum
    };
}